var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-layout bg-gray-100"},[_c('div',{staticClass:"search-layout-main-content container",staticStyle:{"max-width":"90%","padding":"0px"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }